export const ALL_PORTFOLIOS = "all";
//# sourceMappingURL=constants.js.map